/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitChallengeResponseResult
 */
export interface SubmitChallengeResponseResult {
    /**
     * Status of the submission (success)
     * @type {string}
     * @memberof SubmitChallengeResponseResult
     */
    status?: string;
}

/**
 * Check if a given object implements the SubmitChallengeResponseResult interface.
 */
export function instanceOfSubmitChallengeResponseResult(value: object): value is SubmitChallengeResponseResult {
    return true;
}

export function SubmitChallengeResponseResultFromJSON(json: any): SubmitChallengeResponseResult {
    return SubmitChallengeResponseResultFromJSONTyped(json, false);
}

export function SubmitChallengeResponseResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitChallengeResponseResult {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function SubmitChallengeResponseResultToJSON(json: any): SubmitChallengeResponseResult {
    return SubmitChallengeResponseResultToJSONTyped(json, false);
}

export function SubmitChallengeResponseResultToJSONTyped(value?: SubmitChallengeResponseResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

